// ------------------------------------
// PRODUTO
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'products';
    const ref2 = 'styles';
    const refEvtPrefix = 'lp-evt-prod-det-';

    // Oculta/Exibe o sku
    function changeSkuShow() {
      const value = confTheme[ref]['prod-det-sku-show'];
      value == '1' ? $('.prod-sku-v').removeClass('d-none') : $('.prod-sku-v').addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'sku-show', changeSkuShow);

    // Oculta/Exibe a marca
    function changeBrandShow() {
      const value = confTheme[ref]['prod-det-brand-show'];
      value == '1' ? $('.prod-brand-v').removeClass('d-none') : $('.prod-brand-v').addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'brand-show', changeBrandShow);

    // Oculta/Exibe a média de avaliações
    function changeRatingShow() {
      const value = confTheme[ref]['prod-det-rating-avg-show'];
      value == '1' ? $('.produto-det-stars').removeClass('d-none') : $('.produto-det-stars').addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'rating-show', changeRatingShow);

    // Oculta/Exibe o parcelamento
    function changeParcShow() {
      const value = confTheme[ref]['prod-det-parc-show'];
      value == '1' ? $('.prod-preco-parc').removeClass('d-none') : $('.prod-preco-parc').addClass('d-none');
      value == '1' ? $('.produto-det-link').removeClass('d-none') : $('.produto-det-link').addClass('d-none');
      value == '1' ? $('.popup-buy-price-parc').removeClass('d-none') : $('.popup-buy-price-parc').addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'parc-show', changeParcShow);

    // Oculta/Exibe o seletor de quantidade
    function changeQtyShow() {
      const value = confTheme[ref]['prod-det-quantity-show'];
      if (value == '1') {
        $('.produto-det-quantidade').removeClass('d-none');
        $('.produto-det-btn').removeClass('grid-8 grid-sm-12 grid-xs-12').addClass('grid-8');
      } else {
        $('.produto-det-quantidade').addClass('d-none');
        $('.produto-det-btn').removeClass('grid-8 grid-sm-12 grid-xs-12').addClass('grid-8 grid-sm-12 grid-xs-12');
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'quantity-show', changeQtyShow);

    // Oculta/Exibe o popup de compra no celular
    function changePopupBuyShow() {
      const value = confTheme[ref]['popup-buy-show'];
      value == '1' ? $('.popup-buy').removeClass('d-none') : $('.popup-buy').addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'popup-buy-show', changePopupBuyShow);

    // Oculta/Exibe etiqueta de desconto
    function changeDiscShow() {
      const value = confTheme[ref]['prod-det-disc-tag-show'];
      value == '1' ? $('.prod-preco-discount').removeClass('d-none') : $('.prod-preco-discount').addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'disc-tag-show', changeDiscShow);

    // Oculta/Exibe economia
    function changeEconomiaShow() {
      const value = confTheme[ref]['prod-det-economia-show'];
      value == '1' ? $('.prod-preco-economia').removeClass('d-none') : $('.prod-preco-economia').addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'economia-show', changeEconomiaShow);

    // Oculta/Exibe frete grátis
    function changeFreteGratisShow() {
      const value = confTheme[ref]['prod-det-frete-gratis-show'];
      value == '1'
        ? $('.produto-det-frete-gratis').removeClass('d-none')
        : $('.produto-det-frete-gratis').addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'frete-gratis-show', changeFreteGratisShow);

    // Ativa/Desativa zoom nas fotos
    function toggleZoomFotos() {
      const value = confTheme[ref]['prod-det-fotos-zoom'];
      value != '1' ? $('.produto-fotos').removeClass('enable-zoom') : $('.produto-fotos').addClass('enable-zoom');
      destroyProdDetZoom();
      setTimeout(() => {
        initProdDetZoom();
      }, 100);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'fotos-zoom', toggleZoomFotos);

    // Oculta/Exibe descrição
    function changeDescShow() {
      const value = confTheme[ref]['descricao-show'];
      value == '1' ? $('#tab-description').removeClass('d-none') : $('#tab-description').addClass('d-none');
      value == '1'
        ? $('[data-tab="tab-description"]').removeClass('d-none')
        : $('[data-tab="tab-description"]').addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'descricao-show', changeDescShow);

    // Oculta/Exibe informações adicionais
    function changeInfosShow() {
      const value = confTheme[ref]['infos-add-show'];
      value == '1' ? $('#tab-infos').removeClass('d-none') : $('#tab-infos').addClass('d-none');
      value == '1' ? $('[data-tab="tab-infos"]').removeClass('d-none') : $('[data-tab="tab-infos"]').addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'infos-add-show', changeInfosShow);

    // Oculta/Exibe avaliações
    function changeAvaliacoesShow() {
      const value = confTheme[ref]['avaliacoes-show'];
      value == '1' ? $('#tab-avaliacoes').removeClass('d-none') : $('#tab-avaliacoes').addClass('d-none');
      value == '1'
        ? $('[data-tab="tab-avaliacoes"]').removeClass('d-none')
        : $('[data-tab="tab-avaliacoes"]').addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'avaliacoes-show', changeAvaliacoesShow);

    // Oculta/Exibe datas das avaliações
    function changeAvaliacoesDataShow() {
      const value = confTheme[ref]['prod-det-reviews-date-show'];
      value == '1' ? $('.prod-av-item-date').removeClass('d-none') : $('.prod-av-item-date').addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'reviews-date-show', changeAvaliacoesDataShow);

    // Oculta/Exibe perguntas
    function changePerguntasShow() {
      const value = confTheme[ref]['faq-show'];
      value == '1' ? $('#tab-faq').removeClass('d-none') : $('#tab-faq').addClass('d-none');
      value == '1' ? $('[data-tab="tab-faq"]').removeClass('d-none') : $('[data-tab="tab-faq"]').addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'faq-show', changePerguntasShow);

    // Altera a cor do preço
    function changePriceColor() {
      const color = confTheme[ref][ref2]['prod-det-price-color'];
      $root[0].style.setProperty('--prod-det-price-color', color);
    }
    $root.on(refEvtPrefix + 'price-color', changePriceColor);

    // Altera a cor de fundo da tag de desconto
    function changeDiscBgColor() {
      const color = confTheme[ref][ref2]['prod-det-disc-tag-bg'];
      $root[0].style.setProperty('--prod-det-disc-tag-bg', color);
    }
    $root.on(refEvtPrefix + 'disc-tag-bg', changeDiscBgColor);

    // Altera a cor do texto da tag de desconto
    function changeDiscTxtColor() {
      const color = confTheme[ref][ref2]['prod-det-disc-tag-color'];
      $root[0].style.setProperty('--prod-det-disc-tag-color', color);
    }
    $root.on(refEvtPrefix + 'disc-tag-color', changeDiscTxtColor);

    // Altera a cor de fundo da tag de economia
    function changeEconomiaBgColor() {
      const color = confTheme[ref][ref2]['prod-det-economia-bg'];
      $root[0].style.setProperty('--prod-det-economia-bg', color);
    }
    $root.on(refEvtPrefix + 'economia-bg', changeEconomiaBgColor);

    // Altera a cor do texto da tag de economia
    function changeEconomiaTxtColor() {
      const color = confTheme[ref][ref2]['prod-det-economia-color'];
      $root[0].style.setProperty('--prod-det-economia-color', color);
    }
    $root.on(refEvtPrefix + 'economia-color', changeEconomiaTxtColor);

    // Altera o texto e ícone do botão
    function changeBtnBuyIconText() {
      const iconShow = confTheme[ref]['prod-det-btn-buy-icon-show'];
      const icon = confTheme[ref]['prod-det-btn-buy-icon'];
      const iconHtml = iconShow ? getSvgIcon(icon) : '';
      const btnTxt = confTheme[ref]['prod-det-btn-buy-text'];
      $('#btn-buy').html(iconHtml + btnTxt);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'btn-buy-text', changeBtnBuyIconText);

    // Altera o tamanho do ícone do botão
    function changeBtnBuyIconSize() {
      const value = confTheme[ref][ref2]['prod-det-btn-buy-icon-size'];
      $root[0].style.setProperty('--prod-det-btn-buy-icon-size', value);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'btn-buy-icon-size', changeBtnBuyIconSize);

    // Altera o texto do frete grátis
    function changeFreteGratisTxt() {
      const value = confTheme[ref]['prod-det-frete-gratis-text'];
      $('.produto-det-frete-gratis span').html(getSvgIcon('rastreio') + '' + value);
    }
    $root.on(refEvtPrefix + 'frete-gratis-text', changeFreteGratisTxt);

    // Altera o título da seção de descrição
    function changeDescTit() {
      const value = confTheme[ref]['descricao-titulo'];
      $('[data-tab="tab-description"]').text(value);
    }
    $root.on(refEvtPrefix + 'descricao-titulo', changeDescTit);

    // Altera o título da seção de informações
    function changeInfosTit() {
      const value = confTheme[ref]['infos-add-titulo'];
      $('[data-tab="tab-infos"]').text(value);
    }
    $root.on(refEvtPrefix + 'infos-add-titulo', changeInfosTit);

    // Altera o título da seção de avaliações
    function changeAvaliacoesTit() {
      const value = confTheme[ref]['avaliacoes-titulo'];
      $('[data-tab="tab-avaliacoes"]').text(value);
    }
    $root.on(refEvtPrefix + 'avaliacoes-titulo', changeAvaliacoesTit);

    // Altera o título da seção de perguntas
    function changeFaqTit() {
      const value = confTheme[ref]['faq-titulo'];
      $('[data-tab="tab-faq"]').text(value);
    }
    $root.on(refEvtPrefix + 'faq-titulo', changeFaqTit);

    // Altera o título da seção de produtos relacionados
    function changeRelacionadosTit() {
      const value = confTheme[ref]['relacionados-titulo'];
      $('#relacionados-sec .home-title').text(value);
    }
    $root.on(refEvtPrefix + 'relacionados-titulo', changeRelacionadosTit);

    // Oculta/Exibe destaque do pix
    function changePixDestShow() {
      const value = confTheme[ref]['prod-det-disc-pix-show'];
      value == '1' ? $('.pd-disc-pix').removeClass('d-none') : $('.pd-disc-pix').addClass('d-none');
      if (value == '1') {
        $('.pd-disc-pix').css('display', 'inline-flex');
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'disc-pix-show', changePixDestShow);

    // Oculta/Exibe cálculo do frete
    function changeCalcFreteShow() {
      const value = confTheme[ref]['prod-det-ship-calc-show'];
      value == '1'
        ? $('.pag-prod-right .cart-ship-wrp').removeClass('d-none')
        : $('.pag-prod-right .cart-ship-wrp').addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'ship-calc-show', changeCalcFreteShow);

    // Estilo do botão do cálculo do frete
    function changeCalcFreteBtnStyle() {
      const value = confTheme[ref]['prod-det-ship-calc-btn-style'];
      $('#btn-cart-zipcode').removeClass('btn-primary btn-secondary btn-buy btn-white btn-grey').addClass(value);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'ship-calc-btn-style', changeCalcFreteBtnStyle);

    // Oculta/Exibe botão do Whatsapp
    function changeWhatsBtnShow() {
      const value = confTheme[ref]['prod-det-btn-whats-show'];
      value == '1' ? $('.produto-det-btn-whats').removeClass('d-none') : $('.produto-det-btn-whats').addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'btn-whats-show', changeWhatsBtnShow);

    // Altera o texto do botão do Whatsapp
    function changeWhatsBtnTxt() {
      const value = confTheme[ref]['prod-det-btn-whats-txt'];
      $('.produto-det-btn-whats .btn span').html(value);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'btn-whats-txt', changeWhatsBtnTxt);

    // Altera a cor do botão do Whatsapp
    function changeWhatsBtnColor() {
      const color = confTheme[ref][ref2]['prod-det-btn-whats-color'];
      $root[0].style.setProperty('--prod-det-btn-whats-color', color);
    }
    $root.on(refEvtPrefix + 'btn-whats-color', changeWhatsBtnColor);

    // Oculta/Exibe formas de pagamento
    function changePaymentFormsShow() {
      const value = confTheme[ref]['prod-det-payment-forms-show'];
      value == '1'
        ? $('.prod-det-payment-forms').removeClass('d-none')
        : $('.prod-det-payment-forms').addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'payment-forms-show', changePaymentFormsShow);

    // Altera o texto das formas de pagamento
    function changePaymentFormsTxt() {
      const value = confTheme[ref]['prod-det-payment-forms-txt'];
      $('.prod-det-payment-forms-tit').html(mdParse(value, true));
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'payment-forms-txt', changePaymentFormsTxt);

    // Oculta/Exibe destaque frete
    function changeFreteDescShow() {
      const value = confTheme[ref]['prod-det-frete-dest-show'];
      value == '1' ? $('.frete-d-wrp').removeClass('d-none') : $('.frete-d-wrp').addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'frete-dest-show', changeFreteDescShow);

    // Altera o título destaque frete
    function changeFreteDescTit() {
      const value = confTheme[ref]['prod-det-frete-dest-tit'];
      $('.frete-d-tit').html(mdParse(value, true));
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'frete-dest-tit', changeFreteDescTit);

    // Altera o texto destaque frete
    function changeFreteDescTxt() {
      const value = confTheme[ref]['prod-det-frete-dest-txt'];
      $('.frete-d-txt').html(mdParse(value, true));
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'frete-dest-txt', changeFreteDescTxt);
  }
})();

// ------------------------------------
// PESSOAS COMPRANDO
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'products';
    const ref2 = 'styles';
    const refEvtPrefix = 'lp-evt-gatilhos-';

    // Elementos
    const $element = $('.produto-comprando');

    // Oculta/Exibe o elemento
    function changeElShow() {
      const value = confTheme[ref]['comprando-show'];
      value == '1' ? $element.removeClass('d-none') : $element.addClass('d-none');
      if (value == '1') {
        initpBuyCur();
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'comprando-show', changeElShow);

    // Altera o texto
    function changeText() {
      const value = confTheme[ref]['comprando-text'];
      $element.find('.md-text').html(mdParse(value, true));
      initpBuyCur();
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'comprando-text', changeText);
  }
})();

// ------------------------------------
// ESTOQUE
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'products';
    const ref2 = 'styles';
    const refEvtPrefix = 'lp-evt-gatilhos-';

    // Elementos
    const $element = $('.produto-estoque');

    // Oculta/Exibe o elemento
    function changeElShow() {
      const value = confTheme[ref]['estoque-show'];
      value == '1' ? $element.removeClass('d-none') : $element.addClass('d-none');
      if (value == '1') {
        initStockView();
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'estoque-show', changeElShow);

    // Altera o texto
    function changeText() {
      const value = confTheme[ref]['estoque-text'];
      $element.find('.md-text').html(mdParse(value, true));
      initStockView();
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'estoque-text', changeText);

    // Altera o tipo
    function changeTipo() {
      const value = confTheme[ref]['estoque-tipo'];
      $element.data('estoque-tipo', value);
      initStockView();
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'estoque-tipo', changeTipo);

    // Altera a quantidade
    function changeQtde() {
      const value = confTheme[ref]['estoque-ficticio'];
      $element.data('estoque-ficticio', value);
      initStockView();
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'estoque-ficticio', changeQtde);

    // Altera a porcentagem
    function changePercent() {
      const value = confTheme[ref]['estoque-percent'];
      $element.find('.produto-estoque-barra span').css('width', value + '%');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'estoque-percent', changePercent);

    // Altera a cor de fundo
    function changeBgColor() {
      const color = confTheme[ref][ref2]['estoque-bg-color'];
      $root[0].style.setProperty('--estoque-bg-color', color);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'estoque-bg-color', changeBgColor);

    // Altera a cor do texto
    function changeTxtColor() {
      const color = confTheme[ref][ref2]['estoque-txt-color'];
      $root[0].style.setProperty('--estoque-txt-color', color);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'estoque-txt-color', changeTxtColor);
  }
})();

// ------------------------------------
// CONTADOR
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'products';
    const ref2 = 'styles';
    const refEvtPrefix = 'lp-evt-gatilhos-';

    // Elementos
    const $element = $('.countdown-wrapper');

    // Oculta/Exibe o elemento
    function changeElShow() {
      const value = confTheme[ref]['countdown-show'];
      value == '1' ? $element.removeClass('d-none') : $element.addClass('d-none');
      if (value == '1') {
        initCountdowns();
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'countdown-show', changeElShow);

    // Altera o texto
    function changeText() {
      const value = confTheme[ref]['countdown-text'];
      $element.find('.countdown-desc').html(mdParse(value, true));
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'countdown-text', changeText);

    // Altera o tempo do contador
    function changeMinutes() {
      const value = confTheme[ref]['countdown-minutes'];
      $element.find('.countdown').data('minutes', value);
      initCountdowns();
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'countdown-minutes', changeMinutes);

    // Altera a cor de fundo
    function changeBgColor() {
      const color = confTheme[ref][ref2]['countdown-bg-color'];
      $root[0].style.setProperty('--countdown-bg-color', color);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'countdown-bg-color', changeBgColor);

    // Altera a cor do texto
    function changeTxtColor() {
      const color = confTheme[ref][ref2]['countdown-txt-color'];
      $root[0].style.setProperty('--countdown-txt-color', color);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'countdown-txt-color', changeTxtColor);

    // Altera a cor do número
    function changeNumberColor() {
      const color = confTheme[ref][ref2]['countdown-number-color'];
      $root[0].style.setProperty('--countdown-number-color', color);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'countdown-number-color', changeNumberColor);
  }
})();

// ------------------------------------
// TABELA MEDIDAS
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'products';
    const ref2 = 'styles';
    const refEvtPrefix = 'lp-evt-cat-';

    // Elementos
    const $element = $('.produto-det-tabela-medidas');

    // Oculta/Exibe o elemento
    function changeElShow() {
      const value = confTheme[ref]['tabela-medidas-show'];
      value == '1' ? $element.removeClass('d-none') : $element.addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'tabela-medidas-show', changeElShow);

    // Altera o texto do botão
    function changeBtnTxt() {
      const value = confTheme[ref]['tabela-medidas-btn-txt'];
      $element.find('.btn span').html(value);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'tabela-medidas-btn-txt', changeBtnTxt);

    // Altera o texto
    function changeBtnClass() {
      const value = confTheme[ref]['tabela-medidas-btn-class'];
      $element.find('.btn').removeClass('btn-primary btn-secondary btn-buy btn-white btn-grey').addClass(value);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'tabela-medidas-btn-class', changeBtnClass);
  }
})();
